import dayjs, { Dayjs } from 'dayjs'

// 指定月の全日を取得
//   例：2022/2 -> [2022/2/1, 2022/2/2, ..., 2月の最終日]
export function getDays(year: number, month: number): Dayjs[] {
  const firstDate = dayjs(`${year}-${month}-01`)
  const daysInMonth = firstDate.daysInMonth()
  return Array.from({ length: daysInMonth }, (_, i) => firstDate.add(i, 'day'))
}

export function dateIndex(date: Dayjs): number {
  return date.date() - 1
}

/**
 * bit flag管理の曜日用index
 * 月(0) -> 日(6)
 */
export function dayIndex(date: Dayjs): 0 | 1 | 2 | 3 | 4 | 5 | 6 {
  const startSunday = date.day()

  // 1つずらす 0 -> 6, 1 -> 0, ..., 6 -> 5
  return ((startSunday + 6) % 7) as 0 | 1 | 2 | 3 | 4 | 5 | 6
}

export function today(): Dayjs {
  return dayjs()
}
